import React from 'react';
import { useTranslation } from 'react-i18next';
import { LocalizedObject, useLocalizedObject } from 'components/hooks/translation/useLocalizedObject';
import { TrackedFeature, TrackedPage, TRACKING_PARAM_KEYS } from 'services/Logger';
import { useLoggerTracking } from 'components/hooks/logger/useLoggerTracking';

type ShareButtonProps = {
    url: Nullable<string>;
    share: Nullable<LocalizedObject<string[]>>;
    serviceKey: string;
};

export const ShareButton: React.FunctionComponent<ShareButtonProps> = ({
    url,
    share,
    serviceKey,
}) => {
    const { t: translate } = useTranslation('service-description');
    const localize = useLocalizedObject();
    const track = useLoggerTracking();

    const shareLines = share ? localize(share) : [];

    return (
        <a href={getHref(url, shareLines || [])}
            onClick={() => track(TrackedPage.ServiceDetail, TrackedFeature.ShareService, { [TRACKING_PARAM_KEYS.serviceKey]: serviceKey })}
            className="btn btn-lg btn-flat-secondary btn-icon-end"
        >
            {translate('service-description:share')}
            <i className="icon icon-md">share</i>
        </a>
    );
};

const getSubject = (shareLines: string[]) => encodeURIComponent(shareLines[0] || '');

const getBody = (url: Nullable<string>, shareLines: string[]) => {
    const lines = shareLines.slice(1);
    if (url) {
        lines.push(url);
    }
    return encodeURIComponent(lines.join('\n'));
};

const getHref = (url: Nullable<string>, shareLines: string[]) => {
    const subject = getSubject(shareLines);
    const body = getBody(url, shareLines);
    return `mailto:?${subject ? `subject=${subject}&` : ''
        }${body ? `body=${body}` : ''
        }`;
};
